export const ROUTE_ERROR = 'ROUTE_ERROR';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const RATE_LIMIT_ERROR = 'RATE_LIMIT_ERROR';
export const UNRECOVERABLE = 'UNRECOVERABLE';

export const CommonErrorCodes = { ROUTE_ERROR, UNKNOWN_ERROR, RATE_LIMIT_ERROR, UNRECOVERABLE } as const;

export type CommonErrorCode = keyof typeof CommonErrorCodes;
